import React from 'react';
import PropTypes from 'prop-types';

import { Trans } from 'react-i18next';

import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';

class OrderClosingWarning extends React.PureComponent {
    static propTypes = {
        minutes_to_closing: PropTypes.number,
        expected_at: PropTypes.object,
        t: PropTypes.func.isRequired,
    };

    render() {
        if (
            this.props.expected_at === null ||
            this.props.minutes_to_closing === null ||
            this.props.minutes_to_closing > 20
        ) {
            return null;
        }
        const { t, minutes_to_closing } = this.props;
        const today_or_tonight =
            this.props.expected_at.format('H') >= 17
                ? t('tonight')
                : t('today');
        return (
            <div
                data-minutes-to-closing-container
                className="m2g-order-confirmation-minutes-to-closing-container"
            >
                <div className="m2g-alert">
                    <span className="m2g-alert-icon m2g-alert-icon--large m2g-icon m2g-icon--alert" />
                    <div className="m2g-alert-content">
                        {minutes_to_closing <= 1 ? (
                            <strong>{t('store_is_now_closed')}</strong>
                        ) : (
                            <strong>{t('store_is_closing_soon')}</strong>
                        )}
                        <br />
                        <span className="m2g-text--small">
                            {minutes_to_closing <= 1 ? (
                                <span>
                                    {t('store_not_taking_orders', {
                                        today_or_tonight,
                                        interpolation: {
                                            escapeValue: false,
                                        },
                                    })}
                                </span>
                            ) : (
                                <span>
                                    <Trans
                                        i18nKey="order.confirmation:store_minutes_left"
                                        values={{
                                            minutes_to_closing,
                                        }}
                                    >
                                        You have&nbsp;
                                        <strong data-minutes-to-closing>
                                            &nbsp;minutes
                                        </strong>
                                        &nbsp;to confirm your order
                                    </Trans>
                                </span>
                            )}
                        </span>
                    </div>
                </div>
            </div>
        );
    }
}

export default forwardRefWithTranslation('order.confirmation')(
    OrderClosingWarning
);
